export default "__VITE_ASSET__s7MBdFKe__"